import { useEffect, useMemo, useRef, useState } from 'react'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import { ErrorMessage, Form, Formik } from 'formik'
import Button from '../../../components/button/Button'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import { ROUTES_PATH } from '../../../utility/constants'
import { VALIDATION_MESSAGES } from '../../../utility/constantValidationMessages'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import Calendar from '../../../components/calendar/Calendar'
import {
  convertDateFormatCalendar,
  convertTZToDate,
  downloadReceipt,
  generateDropdownOptions,
  paymentDetailsToExcel,
} from '../../../utility/genricFunction'
import './feesCollection.scss'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import { getBatchFromBranch, getFeesCollectionReport } from '../../../store/builders/reports/reports.builder'
import { ColumnGroup } from 'primereact/columngroup'
import { Column } from 'primereact/column'
import { Row } from 'primereact/row'
import PrintIcon from '@mui/icons-material/Print'
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload'
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'
import { getStudentPaymentDetails } from '../../../store/builders/student/student.builder'
import apiClient from '../../../services/axois'
import dayjs from 'dayjs'

function FeesCollection() {
  const dispatch = useDispatch()

  const { loading, pageDropDownLoading } = useSelector((store) => store.reports)
  const reportData = useSelector((store) => store?.reports?.feesCollectionReportData?.paymentDetails)
  const totalPaidAmount = useSelector((store) => store?.reports?.feesCollectionReportData?.totalPaidAmount)
  const { studentPaymentDetails } = useSelector((store) => {
    return store.student
  })
  const branches = useSelector((state) => state?.branch?.branchTableData)
  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

  const batches = useSelector((store) => store.reports.batches)
  const batchOptions = useMemo(() => generateDropdownOptions(batches, 'batchNo', 'batchId'), [batches])

  const userRole = useSelector((state) => state.auth?.user?.result?.userData?.roleName) || {}
  const branchId = useSelector((state) => state.auth?.user?.result?.userData?.branchId)
  const [initialValues] = useState({
    fromDate: '',
    toDate: '',
    branch: userRole == 'branch' ? branchId : '',
    batch: '',
  })
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [isTableOpen, setIsTableOpen] = useState(false)

  useEffect(() => {
    // dispatch(getBranch('active'))
  }, [])

  const validationSchema = Yup.object().shape({
    fromDate: Yup.string().required(VALIDATION_MESSAGES.DATE),
    toDate: Yup.string().required(VALIDATION_MESSAGES.DATE),
    branch: Yup.string().required(VALIDATION_MESSAGES.BRANCH_FORM.BRANCH_NAME_REQUIRED),
    // batch: Yup.string().required(VALIDATION_MESSAGES.BRANCH_FORM.BATCH_REQUIRED),
  })

  function handleFormSubmit(values) {
    setFromDate(values.fromDate)
    setToDate(values.toDate)
    setIsTableOpen(true)

    const data = {
      fromDate: values.fromDate,
      toDate: values.toDate,
      branch: values.branch,
      batch: values.batch,
    }
    dispatch(getFeesCollectionReport(data))
  }

  const breadCrumbsArr = [
    {
      title: 'Fees collection',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: 'Fees collection',
      link: ROUTES_PATH.FEES_COLLECTION_REPORT,
    },
  ]

  const dateBody = (feesCollectionReportDate) => {
    const representative =
      feesCollectionReportDate?.collectionDate && convertTZToDate(feesCollectionReportDate?.collectionDate)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const handleApiCall = async (studentId, rawData) => {
    const response = await apiClient.get(`/student/payment-history/${studentId}?isReport=true`)
    const finalData = response?.data?.result?.filter((e) => e?.studentPaymentId == rawData?.studentPaymentId)
    return {finalData, result: response?.data?.result}
  }
  const verifiedBodyTemplate = (data) => {
    const handleDownloadReceipt = async (id, rawData) => {
      const {finalData, result} = await handleApiCall(id, rawData)
      let dueDetails = result && result?.filter((val) => val?.paymentOn == null)
      await downloadReceipt(
        {
          ...finalData[0],
          type: finalData[0]?.installmentNo == 'registration' ? 'Registration' : '',
        },
        rawData?.studentName,
        dueDetails
      )
    }
    return (
      <>
        <Button
          text={'Export'}
          type={'button'}
          className='download-receipt'
          onClick={() => handleDownloadReceipt(data.studentId, data)}
        >
          <SimCardDownloadIcon />
        </Button>
      </>
    )
  }
  const recieptBodyTemplate = (data) => {

   const receiptNo = dayjs(data?.createdAt).unix()
    return (
      <span>{`${receiptNo}`}</span>
    )
  }

  const columns = [
    {
      field: 'no',
      header: '#',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '2rem' },
    },
    {
      field: 'collectionDate',
      header: 'Collection Date',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
      body: dateBody,
    },
    {
      field: 'courseName',
      header: 'Course',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'courseCode',
      header: 'Code',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'studentName',
      header: 'Student Name',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'receiptNo',
      header: 'Receipt No',
      filter: false,
      filterDisplay: 'row',
      body: recieptBodyTemplate,
      style: { minWidth: '8rem' },
    },
    {
      field: 'paymentMode',
      header: 'Mode',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'paidAmount',
      header: 'Paid Amount',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    // {
    //     field: 'download',
    //     header: "Download Receipt",
    //     filter: false,
    //     filterDisplay: 'row',
    //     style: { minWidth: '8rem' },
    // },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ]

  const printRef = useRef()

  const handleDownloadPfd = useReactToPrint({
    content: () => printRef.current,
  })

  const handleBranchChange = (value, setFieldValue) => {
    setFieldValue('branch', value)
    dispatch(getBatchFromBranch(value))
  }

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer='Total' colSpan={7} className='table-total-row' />
        <Column footer={totalPaidAmount} className='table-total-row' />
        <Column className='table-total-row' />
      </Row>
    </ColumnGroup>
  )

  return (
    <>
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && (
        <div className='feesCollectionReport-wrapper'>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleFormSubmit(values)
            }}
            enableReinitialize
          >
            {({ values, handleChange, handleSubmit, setFieldValue }) => (
              <Form>
                <div className='feesCollectionReport-header'>
                  <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
                </div>

                <div className='feesCollectionReport'>
                  <div className='feesCollectionReport-input-fields'>
                    <Calendar
                      label='From Date'
                      name='fromDate'
                      width={'100%'}
                      required={true}
                      value={values.rateEffectiveDate}
                      onChange={(values) => setFieldValue('fromDate', convertDateFormatCalendar(values))}
                    />

                    <Calendar
                      label='To Date'
                      name='toDate'
                      width={'100%'}
                      required={true}
                      value={values.rateEffectiveDate}
                      onChange={(values) => setFieldValue('toDate', convertDateFormatCalendar(values))}
                    />

                    <div className='feesCollectionReport-input'>
                      <label htmlFor=''>
                        Branch<span className='required-symbol'>*</span>
                      </label>
                      <PageDropdown
                        options={branchOption}
                        selectedValue={values.branch}
                        className={'feesCollectionReport-dropdown'}
                        onChange={(e) => handleBranchChange(e.target.value, setFieldValue)}
                        name={'branch'}
                        placeholder={'Select Branch'}
                        disabled={userRole == 'branch'}
                      />
                      <ErrorMessage name='branch' component='div' className='error-msg' />
                    </div>
                    <div className='feesCollectionReport-input'>
                      <label htmlFor=''>
                        Batch
                      </label>
                      <PageDropdown
                        loading={pageDropDownLoading}
                        options={batchOptions}
                        selectedValue={values.batch}
                        className={'feesCollectionReport-dropdown'}
                        onChange={handleChange}
                        name={'batch'}
                        placeholder={'Select Batch'}
                      />
                      <ErrorMessage name='batch' component='div' className='error-msg' />
                    </div>
                  </div>

                  <div className='report-submit-div'>
                    <Button customClassName={'save-btn'} onClick={handleSubmit}>
                      Submit
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>

          {isTableOpen && (
            <div className='feesCollectionReport-table'>
              <div className='export-option-wrapper'>
                <div className='pdf-excel-export'>
                  <Button
                    text={'Export'}
                    type={'button'}
                    disabled={reportData?.length > 0 ? false : true}
                    onClick={() =>
                      paymentDetailsToExcel(
                        reportData,
                        totalPaidAmount,
                        'Fees Collection Report',
                        'FeesCollectionReport.xlsx',
                      )
                    }
                  >
                    <SimCardDownloadIcon />
                  </Button>

                  <Button
                    text={'Export'}
                    type={'button'}
                    onClick={handleDownloadPfd}
                    disabled={reportData?.length > 0 ? false : true}
                  >
                    <PrintIcon />
                  </Button>
                </div>
              </div>

              <div ref={printRef} className=''>
                <ReportDataTable
                  columns={columns}
                  value={reportData}
                  // loading={loading}
                  footerColumnGroup={footerGroup}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default FeesCollection
